/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMlProjectDto } from '../../models/backend-ml-project-dto';

export interface MonitoringProjectsList$Params {}

export function monitoringProjectsList(
  http: HttpClient,
  rootUrl: string,
  params?: MonitoringProjectsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMlProjectDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringProjectsList.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMlProjectDto>>;
    }),
  );
}

monitoringProjectsList.PATH = '/api/monitoring/projects/';
